import type { OrgChildRef } from '@/types/wire';

/**
 * The org-facing age bucket ("6–8", "9–11") is derived on the server (OPEN_QUESTIONS 18h); the portal never
 * touches a dob. Absent label → the deck's em dash.
 */
export function ageLabel(child: Pick<OrgChildRef, 'ageLabel'>, dash = '—'): string {
  return child.ageLabel && child.ageLabel.trim() ? child.ageLabel : dash;
}

/** "92%" input: round(done/total*100); null when there is nothing to rate (renders "—"). */
export function completionPct(done: number, total: number): number | null {
  return total > 0 ? Math.round((done / total) * 100) : null;
}

/** Sidebar initials disc "DK": first letters of up to two words of the display name or email local part. */
export function initials(name: string | undefined, email: string): string {
  const source = (name && name.trim()) || email.split('@')[0] || '';
  return source
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}
